import { format, addDays } from 'date-fns'
import { UNIVERSAL_DATE_FORMAT } from '@dutchinvoice/shared-utils'
import type { Settings, Invoice, Sender, Recipient, LineItem } from '@dutchinvoice/types'

// Default settings
export const DEFAULT_SETTINGS: Settings = {
    language: 'nl',
    country: 'NL',
    invoiceStartNumber: 300,
    latestInvoiceNumber: 0,
    invoiceNumberFormat: {
        prefix: 'INV',
        includeYear: true,
        yearFormat: 'full',
        separator: '-',
        numberPadding: 4
    },
    paymentMethods: {
        bank: {
            iban: '',
            bic: '',
            accountName: ''
        },
        paypal: {
            email: ''
        },
        mollie: {
            apiKey: '',
            description: 'Invoice {invoiceNumber}'
        }
    },
    defaultNotes: 'Thank you for your business!'
}

// Country data
export const countries = [
    { code: 'NL', name: 'Netherlands', vat: 21 },
    { code: 'BE', name: 'Belgium', vat: 21 },
    { code: 'DE', name: 'Germany', vat: 19 },
    { code: 'FR', name: 'France', vat: 20 },
] as const

// VAT options for dropdown (includes countries + 0% option)
export const vatOptions = [
    { code: '0', name: '0% VAT (Tax Exempt)', vat: 0 },
    ...countries
] as const

// Sample sender for placeholders
const sampleSender: Sender = {
    company: 'De Vries Digital',
    address: 'Amsterdamseweg 123',
    postalCode: '1234 AB',
    city: 'Amsterdam',
    vatNumber: 'NL123456789B01',
    kvkNumber: '12345678',
    isPlaceholder: {
        company: true,
        address: true,
        postalCode: true,
        city: true,
        vatNumber: true,
        kvkNumber: true
    }
}

// Sample recipient for placeholders
const sampleRecipient: Recipient = {
    company: 'Bakker & Co',
    address: 'Rotterdamstraat 45',
    postalCode: '3012 XY',
    city: 'Rotterdam',
    contactName: '',
    email: '',
    additionalInfo: '',
    isPlaceholder: {
        company: true,
        address: true,
        postalCode: true,
        city: true,
        contactName: true,
        email: true,
        additionalInfo: true
    }
}

// Sample line item for placeholders
const sampleLineItem: LineItem = {
    id: crypto.randomUUID(),
    description: 'Web Development Services',
    quantity: '1',
    price: '1200',
    vatRate: '21',
    isPlaceholder: {
        description: true,
        quantity: false,
        price: true,
        vatRate: false
    }
}

// Sample invoice for placeholders and initial state
export const sampleInvoice: Invoice = {
    sender: sampleSender,
    recipient: sampleRecipient,
    items: [sampleLineItem],
    invoiceNumber: '',
    date: format(new Date(), UNIVERSAL_DATE_FORMAT),
    dueDate: format(addDays(new Date(), 14), UNIVERSAL_DATE_FORMAT),
    paymentTerms: '14 days',
    notes: 'Thank you for your business!',
    status: 'concept',
    paymentStatus: 'unpaid',
    discount: {
        type: 'none',
        value: '0'
    },
    emailMessage: '',
    paymentMethods: undefined,
    isPlaceholder: {
        notes: true,
        discount: true,
        emailMessage: true,
        paymentMethods: true
    }
}    